import { CommonAPI } from "../api/Channel/Common";
import { addDays, format, getISOWeek, getYear } from "date-fns";
import fileDownload from "js-file-download";
import _ from "lodash";
import moment from "moment";
import { useLocation } from "react-router";
import { isDate, toMoment } from "./date";
import {
  rxCharNotNumberAndSpecial,
  rxContent,
  rxDocumentNo,
  rxEmail,
  rxFileName,
  rxIP,
  rxNotSpaceAndVietnamese,
  rxNotVietnamese,
  rxNumber,
  rxNumber13,
  rxNumber17,
  rxNumber20,
  rxNumberDot,
  rxOnlyNumberAndLetter,
  rxPassword,
  rxPositiveNumber,
  rxSpecialChar,
  rxSpecialCharAccountName,
  rxSpecialCharChannelName,
  rxSpecialCharNotDot,
  rxSpecialCharNotSpace,
  rxSpecialCharVietnamese,
} from "./regex";

const has = Object.prototype.hasOwnProperty;
export const isEmpty = (prop) => {
  return (
    prop === null ||
    prop === undefined ||
    (has.call(prop, "length") && prop.length === 0) ||
    (prop.constructor === Object && Object.keys(prop).length === 0)
  );
};

export const toObjectWithDateMoment = (obj) => {
  const result = {};
  const rxNumber = new RegExp(/^\d+$/);
  _.forEach(obj, (value, key) => {
    if (
      !!value &&
      _.isString(value) &&
      !rxNumber.test(value) &&
      moment(value, moment.ISO_8601, true).isValid()
    ) {
      result[key] = toMoment(new Date(value));
    } else if (Array.isArray(value)) {
      const t = _.every(value, (x) => {
        return _.isNil(x) || isDate(x);
      });
      t &&
        (result[key] = _.map(value, (x) => (!!x ? toMoment(new Date(x)) : x)));
    } else {
      result[key] = value;
    }
  });
  return result;
};
export const formatUrlFilter = ({ url, page, size }) => {
  return `${url}?page=${page}&size=${size}`;
};

export const objKeyName = (obj, name) =>
  _.find(_.keys(obj), (x) => _.isEqual(x, name));

export const onValue = (value, isMulti) =>
  _.isNil(value) && isMulti ? [] : value;

export const handleTableChange = (e) => (submitFormValues) => {
  const { pageSize, pageIndex } = e;
  submitFormValues((pre) => ({ ...pre, size: pageSize, page: pageIndex || 1 }));
};

export function generateUID() {
  // I generate the UID from two parts here
  // to ensure the random number provide enough bits.
  const firstPart = (Math.random() * 46656) | 0;
  const secondPart = (Math.random() * 46656) | 0;
  return (
    ("000" + firstPart.toString(36)).slice(-3) +
    ("000" + secondPart.toString(36)).slice(-3)
  );
}

export const downloadFileLocal = (origin, fileName) => {
  const { name } = origin;
  const url = URL.createObjectURL(origin);
  const downloadLink = document.createElement("a");
  document.body.appendChild(downloadLink);
  downloadLink.href = url;
  downloadLink.target = "_self";
  downloadLink.download = fileName ?? name;
  downloadLink.click();
};

export const handleGetAllPath = (options) => {
  let arr = [];
  options.forEach((element) => {
    const listArr = element?.children
      ? element.children?.filter((v) => v.path)
      : [];
    arr = [...arr, ...listArr];
    element?.children?.forEach((ele2) => {
      if (ele2.children) {
        arr = [...arr, ...handleGetAllPath([ele2])];
      }
    });
  });
  return arr;
};

export const flatMenu = (route) => {
  let arr = [...route];
  route.forEach((element) => {
    if (element?.children?.length > 0) {
      arr = [...arr, ...flatMenu(element?.children)];
    }
  });
  return arr;
};

export const checkChangeArray = (oldArr = [], newArr = [], compareName) => {
  const additionalArr = oldArr
    ? newArr.filter(
        (v) =>
          !oldArr.some((v2) => v2?.[`${compareName}`] === v?.[`${compareName}`])
      )
    : newArr;
  const deletedArr = newArr
    ? oldArr.filter(
        (v) =>
          !newArr.some((v2) => v2?.[`${compareName}`] === v?.[`${compareName}`])
      )
    : oldArr;
  return { additionalArr, deletedArr };
};

export const changeToAlias = (string) => {
  // Chuyển toàn bộ Tiếng Việt sang không dấu viết thường và các kí tự đặc biệt thành dấu "-"
  return string
    .trim()
    .normalize("NFD")
    .toLowerCase()
    .replace(/\s\s+/g, " ")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(
      /`|~|!|@|"|#|\||\$|%|\^|&|\*|\(|\)|\+|=|,|\.|\/|\?|>|<|'|"|:|;|_/gi,
      ""
    )
    .replace(/ /g, "-")
    .replace(/-----/gi, "-")
    .replace(/----/gi, "-")
    .replace(/---/gi, "-")
    .replace(/--/gi, "-")
    .replace(/"-|-"|"/gi, "");
};

export const convertPayloadOption = (v) => {
  return !!v && !_.isEqual(v, "ALL");
};
export function compareOptions(a, b) {
  const valueA = a?.name?.toUpperCase();
  const valueB = b?.name?.toUpperCase();
  let comparison = 0;
  if (valueA > valueB) {
    comparison = 1;
  } else if (valueA < valueB) {
    comparison = -1;
  }
  return comparison;
}

export const checkRegexExpSpecial = (value) => {
  return rxSpecialChar.test(value);
};

export const checkRegexPassword = (value) => {
  return rxPassword.test(value);
};

export const checkRegexExpSpecialAndVietnamese = (value) => {
  return !rxSpecialCharVietnamese.test(value);
};

export const checkRegexExpSpecialChannelName = (value) => {
  return rxSpecialCharChannelName.test(value);
};

export const checkRegexExpSpecialAccountName = (value) => {
  return rxSpecialCharAccountName.test(value);
};

export const checkRegexNotNumber = (value) => {
  return !rxNumber.test(value);
};

export const checkRegexBICard = (value) => {
  return !rxNumber17.test(value);
};

export const checkRegexCINCard = (value) => {
  return !rxNumber13.test(value);
};

// export const checkRegexStaffId = (value) => {
//   return !rxNumber10.test(value);
// };

export const checkRexgexIP = (value) => {
  return !rxIP.test(value);
};

export const checkRegexPPCard = (value) => {
  return !rxNumber20.test(value);
};

export const checkRegexNumberDot = (value) => {
  return !rxNumberDot.test(value);
};

export const checkRegexEmail = (value) => {
  return !rxEmail.test(value);
};

export const checkRegexNotSpace = (value) => {
  return !rxSpecialCharNotSpace.test(value);
};

export const checkRegexTextNumberSpecial = (value) => {
  return !rxSpecialCharNotDot.test(value);
};

export const checkPositiveNumber = (value) => {
  return !rxPositiveNumber.test(value);
};

export const checkFullNameHaiTi = (value) => {
  return !rxCharNotNumberAndSpecial.test(value);
};

export const checkFileName = (value) => {
  return !rxFileName.test(value);
};

export const checkRegexContent = (value) => {
  return !rxContent.test(value);
};

export const checkRegexDocumentNo = (value) => {
  return !rxDocumentNo.test(value);
};

/**
 * USE FOR:::
 * - Bank Account no
 */
export const checkRegexOnlyNumberAndLetter = (value) => {
  return !rxOnlyNumberAndLetter.test(value);
};

/**
 * USE FOR:::
 * - ID Number/Paper Number
 */
export const checkRegexVietnameseAndSpace = (value) => {
  return !rxNotSpaceAndVietnamese.test(value);
};

/**
 * USE FOR:::
 * - Bank Account Name / Adresss
 */
export const checkRegexVietnamese = (value) => {
  return !rxNotVietnamese.test(value);
};

export const checkHaityPhoneNumber = (value) => {
  // const result =  value.startsWith("509") && value.length === 11;
  const result =
    ((value.startsWith("50955") ||
      value.startsWith("50943") ||
      value.startsWith("50942") ||
      value.startsWith("50941") ||
      value.startsWith("50940") ||
      value.startsWith("50935") ||
      value.startsWith("50933") ||
      value.startsWith("50956") ||
      value.startsWith("50932") ||
      value.startsWith("50958")) &&
      value.length === 11) ||
    ((value.startsWith("55") ||
      value.startsWith("43") ||
      value.startsWith("42") ||
      value.startsWith("41") ||
      value.startsWith("40") ||
      value.startsWith("35") ||
      value.startsWith("33") ||
      value.startsWith("56") ||
      value.startsWith("32") ||
      value.startsWith("58")) &&
      value.length === 8);
  return !result;
};

export const isInteger = (values) => {
  const { floatValue, formattedValue } = values || {};
  return formattedValue === "" || floatValue > 0;
};

export const getTypeFile = (file) => {
  let type = "";

  switch (file.type) {
    case "application/pdf":
      type = "pdf";
      break;
    case "image/jpg":
      type = "jpg";
      break;
    case "image/png":
      type = "png";
      break;
    case "image/jpeg":
      type = "jpeg";
      break;
    case "image/gif":
      type = "gif";
      break;
    // case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    //   type = "docx";
    //   break;
    default:
      type = "docx";
  }

  return type;
};

export function trimObject(obj) {
  const trim = {};
  Object.entries(obj).forEach((v) => {
    trim[`${v[0]}`] = typeof v[1] === "string" ? v[1].trim() : v[1];
  });
  return trim;
}

export function scrollToTop(selector) {
  const section = document.querySelector(selector);
  section.scrollIntoView({ behavior: "smooth", block: "start" });
}

export async function downloadFile({ id, fileName }) {
  const { data, isSuccess } = await CommonAPI.downloadFile(id);
  isSuccess && fileDownload(data, fileName);
}

export function getFileExtension(filename) {
  /**
   * Solution found on:  https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript/1203361#1203361
   */
  // return /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : undefined;
  return (
    filename.substring(filename.lastIndexOf(".") + 1, filename.length) ||
    filename
  );
}

export function usePathUrl(pathName) {
  const location = useLocation();
  const path = _.split(location.pathname, "/");
  const result = path.find((item) => item === pathName);

  return result;
}
export const extractTextFromHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

export function checkIsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function parseStringToNumber(number) {
  return Number(number.replace(/,/g, ""));
}

export const weekOptions = Array.from(Array(52).keys(), (index) => {
  return { value: index + 1, label: `Week ${index + 1}` };
});

export const weekNumberOptions = (year, t) => {
  const currentYear = getYear(new Date());
  const isPrevYear = year < currentYear;
  const weekNumberOfYear = getISOWeek(
    isPrevYear ? new Date(year, 11, 31) : new Date()
  );
  // console.log("weekNumberOfYear: ", );

  return Array.from(Array(weekNumberOfYear).keys(), (index) => {
    return { value: index + 1, label: `${t(`header.week`)} ${index + 1}` };
  });
};

export function getDateRangeForWeek(weekNumber, year) {
  const startDate = new Date(year, 0, 1 + (weekNumber - 1) * 7);
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);

  const rangeDate = [];

  for (let i = 0; i < 7; i++) {
    if (i > 0) {
      rangeDate.push(format(addDays(startDate, i), "dd/MM"));
    } else {
      rangeDate.push(format(startDate, "dd/MM"));
    }
  }

  return { startDate, endDate, rangeDate };
}

export function calculateStep(number) {
  // Devine value into 5 parts
  const average = `${Math.floor(number / 5)}`;
  // Found number is hundred, thousand, million
  const unitNumber =
    Number(average) > 10 ? Math.pow(10, average.length - 1) : 1;
  const unitStep = Number(average.charAt(0)) * unitNumber;

  return unitStep;
}
